/* eslint-disable */
/*********************************************************
/ Glorious generated code by DoneDone's Code Generator.
/ Written by Ka Wai Cheung.
/ Generated on Tuesday, June 24, 2025 9:10:01 PM UTC
/ Don't modify this by hand silly!
*********************************************************/

import { RequestHandler } from '../request-handler'
import {
  IMailboxesInputCreate,
  IMailboxesInputOfficeHours,
  IMailboxesInputIncomingEmailSettings,
  IMailboxesInputOutgoingFromAddress,
  IMailboxesInputManageCustomFilter,
  IMailboxesInputCreateSavedReply,
  IMailboxesInputCreateAutoResponse,
  IMailboxesInputGeneralSettings,
  IMailboxesInputUpdateCustomFilter,
  IMailboxesInputUpdateSavedReply,
  IMailboxesInputUpdateAutoResponse,
  IMailboxesInputChangeWorkflow,
  IMailboxesInputTicketPortal,
  IMailboxesInputChecklistTemplateCreate,
  IMailboxesInputChecklistTemplateUpdate,
} from '../types/request.types'
import {
  IGenericJSONMessage,
  IChecklist,
  IMailboxesOutputMetrics,
  ICreateNewConversationsStatus,
  IItemForSelection,
  IProjectsOutputNote,
  ILastUpdatedEpochTime,
  IProjectWithWorkflow,
  IProjectsOutputAssignPeople,
  IPersonWithEmail,
  IProjectsOutputMyNotifications,
  IMailboxesOutputOutgoingSignatureTemplate,
  IPriorityLevelForSelection,
  IStatusForSelection,
  IMailboxesOutputUpdatableMailboxes,
  IProjectsOutputIntegrations,
  IProjectsOutputProjectForHome,
  IProjectDailyActivityLogs,
  ILimitCheck,
  IMailboxesOutputDetail,
  IWorkflowForSelection,
  IMailboxesOutputAutoForwarding,
  IMailboxesOutputIncomingEmailAddress,
  IMailboxesOutputIncomingEmailSettings,
  IMailboxesOutputOutgoingEmailSettings,
  IMailboxesOutputPostmarkSenderSignatureConfirmationUrl,
  IMailboxesOutputSavedReplies,
  IMailboxesOutputTicketPortal,
  IMailboxesOutputAutoResponder,
  IMailboxesOutputOfficeHours,
  IConvoForForwardingVerification,
  IMailboxesOutputMostRecentGmailConfirmationLink,
  IMailboxesOutputMostRecentZohoConfirmationCode,
  IMailboxesOutputGeneralSettings,
  IMailboxesOutputFilterOptionsForListing,
  IMailboxesOutputDefaultFilterOptionCounts,
  IMailboxesOutputConfirmAutoForwardingTestEmail,
  IMailboxesOutputLastLinkedTaskInternalProjectID,
  IProjectsOutputShowInfoPanelOnLanding,
  IMailboxesOutputCreate,
  IPostSuccess,
  IChecklistTemplate,
} from '../types/response.types'

export default new class MailboxesAPI extends RequestHandler {
  /****** GET methods *****/
  public async get_Metrics(
    mailbox_id: any,
  ): Promise<IMailboxesOutputMetrics> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/metrics`,
    })
  }
  public async get_CreateNewConversationsCheck(
    mailbox_id: any,
  ): Promise<ICreateNewConversationsStatus> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/create-new-conversations-check`,
    })
  }
  public async get_Title(
    mailbox_id: any,
  ): Promise<IItemForSelection> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/title`,
    })
  }
  public async get_Note(
    mailbox_id: any,
  ): Promise<IProjectsOutputNote> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/note`,
    })
  }
  public async get_MostRecentLastUpdatedEpochTime(
  ): Promise<ILastUpdatedEpochTime> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/most-recent-last-updated-epoch-time`,
    })
  }
  public async get_LastUpdatedEpochTime(
    mailbox_id: any,
  ): Promise<ILastUpdatedEpochTime> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/last-updated-epoch-time`,
    })
  }
  public async get_WithWorkflow(
    mailbox_id: any,
  ): Promise<IProjectWithWorkflow> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/with-workflow`,
    })
  }
  public async get_AssignPeople(
    mailbox_id: any,
  ): Promise<IProjectsOutputAssignPeople> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/assign-people`,
    })
  }
  public async get_Members(
    mailbox_id: any,
  ): Promise<IPersonWithEmail[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/members`,
    })
  }
  public async get_MembershipCandidates(
    mailbox_id: any,
  ): Promise<IPersonWithEmail[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/membership-candidates`,
    })
  }
  public async get_MyNotifications(
    mailbox_id: any,
  ): Promise<IProjectsOutputMyNotifications> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/my-notifications`,
    })
  }
  public async get_OutgoingSignatureTemplate(
    mailbox_id: any,
  ): Promise<IMailboxesOutputOutgoingSignatureTemplate> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/outgoing-signature-template`,
    })
  }
  public async get_Assignees(
    mailbox_id: any,
  ): Promise<IPersonWithEmail[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/assignees`,
    })
  }
  public async get_Priorities(
    mailbox_id: any,
  ): Promise<IPriorityLevelForSelection[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/priorities`,
    })
  }
  public async get_Statuses(
    mailbox_id: any,
  ): Promise<IStatusForSelection[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/statuses`,
    })
  }
  public async get_Customers(
    mailbox_id: any,
  ): Promise<IPersonWithEmail[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/customers`,
    })
  }
  public async get_Tags(
    mailbox_id: any,
  ): Promise<IItemForSelection[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/tags`,
    })
  }
  public async get_UpdatableMailboxes(
    mailbox_id: any,
  ): Promise<IMailboxesOutputUpdatableMailboxes> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/updatable-mailboxes`,
    })
  }
  public async get_Integrations(
    mailbox_id: any,
  ): Promise<IProjectsOutputIntegrations> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/integrations`,
    })
  }
  public async get_Index(
  ): Promise<IProjectsOutputProjectForHome[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes`,
    })
  }
  public async get_DailyActivityLogs(
  ): Promise<IProjectDailyActivityLogs> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/daily-activity-logs`,
    })
  }
  public async get_LimitCheck(
  ): Promise<ILimitCheck> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/limit-check`,
    })
  }
  public async get_ForSelection(
  ): Promise<IItemForSelection[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/for-selection`,
    })
  }
  public async get_Detail(
    mailbox_id: any,
  ): Promise<IMailboxesOutputDetail> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}`,
    })
  }
  public async get_Workflows(
  ): Promise<IWorkflowForSelection[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/workflows`,
    })
  }
  public async get_AutoForwarding(
    mailbox_id: any,
  ): Promise<IMailboxesOutputAutoForwarding> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/auto-forwarding`,
    })
  }
  public async get_GenerateIncomingEmailAddress(
    mailbox_id: any,
  ): Promise<IMailboxesOutputIncomingEmailAddress> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/incoming-email-address/generate`,
    })
  }
  public async get_IncomingEmailSettings(
    mailbox_id: any,
  ): Promise<IMailboxesOutputIncomingEmailSettings> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/incoming-email-settings`,
    })
  }
  public async get_OutgoingEmailSettings(
    mailbox_id: any,
  ): Promise<IMailboxesOutputOutgoingEmailSettings> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/outgoing-email-settings`,
    })
  }
  public async get_PostmarkSenderSignatureConfirmationUrl(
    mailbox_id: any,
  ): Promise<IMailboxesOutputPostmarkSenderSignatureConfirmationUrl> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/postmark-sender-signature-confirmation-url`,
    })
  }
  public async get_ResendOutgoingFromAddressVerification(
    mailbox_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/outgoing-email-settings/resend-from-address-verification`,
    })
  }
  public async get_SavedReplies(
    mailbox_id: any,
  ): Promise<IMailboxesOutputSavedReplies> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/saved-replies`,
    })
  }
  public async get_TicketPortal(
    mailbox_id: any,
  ): Promise<IMailboxesOutputTicketPortal> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/ticket-portal`,
    })
  }
  public async get_AutoResponder(
    mailbox_id: any,
  ): Promise<IMailboxesOutputAutoResponder> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/auto-responder`,
    })
  }
  public async get_OfficeHours(
    mailbox_id: any,
  ): Promise<IMailboxesOutputOfficeHours> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/office-hours`,
    })
  }
  public async get_MostRecentCustomerCreatedConvoForForwardingVerifications(
    mailbox_id: any,
  ): Promise<IConvoForForwardingVerification[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/most-recent-customer-created-conversation-for-forwarding-verifications`,
    })
  }
  public async get_MostRecentGmailConfirmationLink(
    mailbox_id: any,
  ): Promise<IMailboxesOutputMostRecentGmailConfirmationLink> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/most-recent-gmail-confirmation-link`,
    })
  }
  public async get_MostRecentZohoConfirmationCode(
    mailbox_id: any,
  ): Promise<IMailboxesOutputMostRecentZohoConfirmationCode> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/most-recent-zoho-confirmation-code`,
    })
  }
  public async get_GeneralSettings(
    mailbox_id: any,
  ): Promise<IMailboxesOutputGeneralSettings> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/general-settings`,
    })
  }
  public async get_FilterOptionsForListing(
    mailbox_id: any,
  ): Promise<IMailboxesOutputFilterOptionsForListing> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/filter-options/listing`,
    })
  }
  public async get_DefaultFilterOptionCounts(
    mailbox_id: any,
  ): Promise<IMailboxesOutputDefaultFilterOptionCounts> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/default-filter-option-counts`,
    })
  }
  public async get_ConfirmAutoForwardingTestEmail(
    mailbox_id: any,
  ): Promise<IMailboxesOutputConfirmAutoForwardingTestEmail> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/auto-forwarding/confirm-test-email`,
    })
  }
  public async get_LastLinkedTaskInternalProjectID(
    mailbox_id: any,
  ): Promise<IMailboxesOutputLastLinkedTaskInternalProjectID> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/last-linked-task-internal-project-id`,
    })
  }
  public async get_ShowInfoPanelOnLanding(
    mailbox_id: any,
  ): Promise<IProjectsOutputShowInfoPanelOnLanding> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/show-info-panel-on-landing`,
    })
  }
  public async get_ChecklistTemplates(
    mailbox_id: any,
  ): Promise<IChecklistTemplate[]> {
    return await this.get({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/checklist-templates`,
    })
  }
  /****** POST methods *****/
  public async post_ChecklistTemplateAddToConvo(
    mailbox_id: any,
    checklist_template_id: any,
    convo_id: any,
  ): Promise<IChecklist> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/checklist-templates/${checklist_template_id}/add-to-convo/${convo_id}`,
    })
  }
  public async post_Archive(
    mailbox_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/archive`,
    })
  }
  public async post_Delete(
    mailbox_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/delete`,
    })
  }
  public async post_Restore(
    mailbox_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/restore`,
    })
  }
  public async post_Favorite(
    mailbox_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/favorite`,
    })
  }
  public async post_Unfavorite(
    mailbox_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/unfavorite`,
    })
  }
  public async post_AssignPeople(
    mailbox_id: any,
    listPeopleIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/assign-people`,
      data: {
        listPeopleIDs
      },
    })
  }
  public async post_MyNotifications(
    mailbox_id: any,
    notificationOptionID: number,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/my-notifications`,
      data: {
        notificationOptionID
      },
    })
  }
  public async post_SetSlackIntegration(
    mailbox_id: any,
    channelID: string,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/integrations/slack`,
      data: {
        channelID
      },
    })
  }
  public async post_RemoveSlackIntegration(
    mailbox_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/integrations/slack/remove`,
    })
  }
  public async post_SetGlipIntegration(
    mailbox_id: any,
    apiToken: string,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/integrations/glip`,
      data: {
        apiToken
      },
    })
  }
  public async post_RemoveGlipIntegration(
    mailbox_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/integrations/glip/remove`,
    })
  }
  public async post_SetHarvestEnabled(
    mailbox_id: any,
    enabled: boolean,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/integrations/harvest`,
      data: {
        enabled
      },
    })
  }
  public async post_Create(
    data: IMailboxesInputCreate,
  ): Promise<IMailboxesOutputCreate> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes`,
      data,
    })
  }
  public async post_AutoForwarding(
    mailbox_id: any,
    listForwardingEmailAddresses: string[],
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/auto-forwarding`,
      data: {
        listForwardingEmailAddresses
      },
    })
  }
  public async post_OfficeHours(
    mailbox_id: any,
    data: IMailboxesInputOfficeHours,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/office-hours`,
      data,
    })
  }
  public async post_SendTestEmailToAutoForwardingAddress(
    mailbox_id: any,
    email: string,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/auto-forwarding/send-test-email`,
      data: {
        email
      },
    })
  }
  public async post_IncomingEmailSettings(
    mailbox_id: any,
    data: IMailboxesInputIncomingEmailSettings,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/incoming-email-settings`,
      data,
    })
  }
  public async post_OutgoingFromAddress(
    mailbox_id: any,
    data: IMailboxesInputOutgoingFromAddress,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/outgoing-email-settings/from-address`,
      data,
    })
  }
  public async post_OutgoingSignatureTemplate(
    mailbox_id: any,
    signature: string,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/outgoing-signature-template`,
      data: {
        signature
      },
    })
  }
  public async post_ConfirmPendingOutgoingFromAddress(
    mailbox_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/outgoing-email-settings/confirm-pending-from-address`,
    })
  }
  public async post_CreateCustomFilter(
    mailbox_id: any,
    data: IMailboxesInputManageCustomFilter,
  ): Promise<IPostSuccess> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/custom-filters`,
      data,
    })
  }
  public async post_CreateSavedReply(
    mailbox_id: any,
    data: IMailboxesInputCreateSavedReply,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/saved-replies`,
      data,
    })
  }
  public async post_CreateAutoResponse(
    mailbox_id: any,
    data: IMailboxesInputCreateAutoResponse,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/auto-responses`,
      data,
    })
  }
  public async post_GeneralSettings(
    mailbox_id: any,
    data: IMailboxesInputGeneralSettings,
  ): Promise<IGenericJSONMessage> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/general-settings`,
      data,
    })
  }
  public async post_ChecklistTemplateCreate(
    mailbox_id: any,
    data: IMailboxesInputChecklistTemplateCreate,
  ): Promise<IChecklistTemplate> {
    return await this.post({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/checklist-templates`,
      data,
    })
  }
  /****** PUT methods *****/
  public async put_RequestAccess(
    mailbox_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/request-access`,
    })
  }
  public async put_Title(
    mailbox_id: any,
    name: string,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/title`,
      data: {
        name
      },
    })
  }
  public async put_UpdateCustomFilter(
    mailbox_id: any,
    custom_filter_id: any,
    data: IMailboxesInputUpdateCustomFilter,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/custom-filters/${custom_filter_id}`,
      data,
    })
  }
  public async put_UpdateSavedReply(
    mailbox_id: any,
    saved_reply_id: any,
    data: IMailboxesInputUpdateSavedReply,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/saved-replies/${saved_reply_id}`,
      data,
    })
  }
  public async put_UpdateAutoResponse(
    mailbox_id: any,
    auto_response_id: any,
    data: IMailboxesInputUpdateAutoResponse,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/auto-responses/${auto_response_id}`,
      data,
    })
  }
  public async put_AddPeople(
    mailbox_id: any,
    listPeopleIDs: number[],
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/people`,
      data: {
        listPeopleIDs
      },
    })
  }
  public async put_ChangeWorkflow(
    mailbox_id: any,
    data: IMailboxesInputChangeWorkflow,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/change-workflow`,
      data,
    })
  }
  public async put_Note(
    mailbox_id: any,
    description: string,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/note`,
      data: {
        description
      },
    })
  }
  public async put_ToggleJobs(
    mailbox_id: any,
    enabled: boolean,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/toggle-jobs`,
      data: {
        enabled
      },
    })
  }
  public async put_TicketPortal(
    mailbox_id: any,
    data: IMailboxesInputTicketPortal,
  ): Promise<IGenericJSONMessage> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/ticket-portal`,
      data,
    })
  }
  public async put_ChecklistTemplateUpdate(
    mailbox_id: any,
    checklist_template_id: any,
    data: IMailboxesInputChecklistTemplateUpdate,
  ): Promise<IChecklistTemplate> {
    return await this.put({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/checklist-templates/${checklist_template_id}`,
      data,
    })
  }
  /****** DELETE methods *****/
  public async delete_ChecklistTemplateDelete(
    mailbox_id: any,
    checklist_template_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/checklist-templates/${checklist_template_id}`,
    })
  }
  public async delete_DeleteSavedReply(
    mailbox_id: any,
    saved_reply_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/saved-replies/${saved_reply_id}`,
    })
  }
  public async delete_DeleteAutoResponse(
    mailbox_id: any,
    auto_response_id: any,
  ): Promise<IGenericJSONMessage> {
    return await this.delete({
      url: `/[[ACCOUNT_ID]]/mailboxes/${mailbox_id}/auto-responses/${auto_response_id}`,
    })
  }
}()
